module.exports = require("react-color");